<input #fileInput type="file" [multiple]="multiple" [attr.accept]="accept" (change)="onFileInputChange($event)" />

@if (variant === 'dropzone') {
  <div
    class="doc-import-zone"
    [class.doc-import-zone--dragging]="isDragging"
    [class.doc-import-zone--disabled]="disabled"
    role="button"
    tabindex="0"
    (click)="triggerFileInput()"
    (keydown.enter)="triggerFileInput()"
    (keydown.space)="$event.preventDefault(); triggerFileInput()"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    @if (isDragging) {
      <div class="doc-import-zone__overlay">
        <div class="doc-import-zone__drag-icon"><i class="ph ph-upload-simple doc-import-zone__pulse"></i></div>
        <h3>{{ 'tenders.responses.documents.dropzone-dragging' | translate }}</h3>
      </div>
    }

    <div class="doc-import-zone__icon"><i class="ph ph-upload-simple"></i></div>
    @if (mainTitle) {
      <h3>{{ mainTitle }}</h3>
    }
    @if (subtitle) {
      <p class="doc-import-zone__subtitle">{{ subtitle }}</p>
    }
    @if (showHints) {
      <div class="doc-import-zone__hints" (click)="$event.stopPropagation()">
        @if (hints?.length) {
          @for (hint of hints; track hint.label) {
            <span class="doc-import-zone__hint" [class.doc-import-zone__hint--highlight]="hint.highlight">{{ hint.label }}</span>
          }
          @if (footnote) {
            <span class="doc-import-zone__hint doc-import-zone__hint--muted">{{ footnote }}</span>
          }
        } @else {
          <span class="doc-import-zone__hint doc-import-zone__hint--highlight">
            <i class="ph ph-archive" aria-hidden="true"></i>
            {{ 'tenders.responses.documents.hint-zip' | translate }}
          </span>
          <span class="doc-import-zone__hint">{{ 'tenders.responses.documents.hint-pdf' | translate }}</span>
          <span class="doc-import-zone__hint">{{ 'tenders.responses.documents.hint-docx' | translate }}</span>
          <span class="doc-import-zone__hint">{{ 'tenders.responses.documents.hint-xlsx' | translate }}</span>
          <span class="doc-import-zone__hint doc-import-zone__hint--muted">{{
            'tenders.responses.documents.hint-max-size' | translate
          }}</span>
        }
      </div>
    }
    <button type="button" class="doc-import-zone__btn" (click)="triggerFileInput(); $event.stopPropagation()">
      {{ browseLabel | translate }}
    </button>
  </div>
} @else {
  <div
    class="doc-import-zone__add"
    [class.doc-import-zone__add--dragging]="isDragging"
    [class.doc-import-zone--disabled]="disabled"
    role="button"
    tabindex="0"
    (click)="triggerFileInput()"
    (keydown.enter)="triggerFileInput()"
    (keydown.space)="$event.preventDefault(); triggerFileInput()"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    @if (isDragging) {
      <i class="ph ph-download" aria-hidden="true"></i>
      {{ 'tenders.responses.documents.dropzone-dragging' | translate }}
    } @else {
      <i class="ph ph-plus" aria-hidden="true"></i>
      {{ addLabel | translate }}
    }
  </div>
}
